import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { ProviderServices } from '../../../services/chat/createProviderServices';
import { ChatSessionLoadResult } from '../../../services/chat/interfaces/IChatSessionsService';
import { mapUpdateChatSessionCommandToProviderRequest } from '../mappers/mapUpdateChatSessionCommandToProviderRequest';
import { UpdateChatSessionCommand } from '../models/UpdateChatSessionCommand';
import { Agent } from '../../../domain/agents/models/Agent';

export interface UpdateChatSessionHandlerInput {
	command: UpdateChatSessionCommand;
	session: ChatSession;
	accessToken: string;
	providerServices: ProviderServices;
	resolvedAgent?: Agent | null;
}

export const updateChatSessionHandler = async ({
	command,
	session,
	accessToken,
	providerServices,
	resolvedAgent,
}: UpdateChatSessionHandlerInput): Promise<ChatSessionLoadResult> => {
	const selectedProviderServices = providerServices.providerServicesRouter.getProviderServices(session.providerType);

	if (!selectedProviderServices.sessionWrite) {
		throw new Error(`Update is not supported for provider type ${session.providerType}.`);
	}

	const request = mapUpdateChatSessionCommandToProviderRequest({
		command,
		session,
		resolvedAgent,
	});

	return selectedProviderServices.sessionWrite.updateChatAsync(session.id, request, accessToken);
};

export default updateChatSessionHandler;
